<template>
  <validation-observer ref="editTable" slim>
    <div class="form-container">
      <div class="wrapper">
        <fields
          :isEdit="isEdit"
          :detail="item"
          :options="options"
        />
        <br>
      </div>
      <overburden-component
        :isEdit="isEdit"
        :detail-current-month="item.volume_current_month"
        :detail-previous-month="item.volume_previous_month"
        :attachment="attachment"
        @upload="fetchAttachment"
      />
      <div class="d-flex justify-content-end mt-5">
        <b-button
          class="btn-reset mr-2"
          variant="outline-info"
          size="sm"
          @click="onClickBack"
        >
          Back
        </b-button>
        <b-button
          v-if="canEdit && !isEdit && this.item.status.toLowerCase() !== 'submitted'"
          class="btn-custom"
          variant="info"
          size="sm"
          @click="onClickEdit"
        >
          Edit
        </b-button>
        <b-button
          v-if="canEdit && isEdit"
          class="btn-custom"
          variant="info"
          size="sm"
          @click="onClickSubmit"
        >
          Submit
        </b-button>
      </div>
    </div>
    <modal-successful :message="text" />
  </validation-observer>
</template>

<script>
import api from '@/api'
import Fields from './Field'
import ModalSuccessful from '@/partials/ModalSuccessful'
import OverburdenComponent from '@/partials/overburdenComponent.vue'
import { hasPermission } from '@/utils/permissions'
import { OVERBURDEN_EDIT, OVERBURDEN_UPLOAD } from '@/fixtures'

export default {
  components: {
    Fields,
    OverburdenComponent,
    ModalSuccessful
  },

  data: () => ({
    canEdit: hasPermission(OVERBURDEN_EDIT),
    canPrintExport: hasPermission(OVERBURDEN_UPLOAD),
    numberOfColumns: 4,
    currentMonthFields: [
      { key: 'pit', label: 'Pit', tdClass: 'text-center align-middle p-0', thStyle: 'width: 200px' },
      { key: 'typeOb', label: 'Type OB', tdClass: 'text-center p-0' },
      { key: 'statusPayment', label: 'Status Payment', tdClass: 'text-center p-0' },
      { key: 'actualDistance', label: 'Actual Distance', tdClass: 'text-center p-0' },
      { key: 'volumeOb', label: 'Volume OB', tdClass: 'text-center p-0' },
      { key: 'unitPrice', label: 'Unit Price (IDR/BCM)', tdClass: 'text-center p-0' },
      { key: 'totalPrice', label: 'Total Price (IDR)', tdClass: 'text-center p-0' }
    ],
    previousMonthFields: [
      { key: 'date', label: 'Month', tdClass: 'text-center p-0', thStyle: 'width: 160px' },
      { key: 'name', label: 'Pit', tdClass: 'text-center p-0', thStyle: 'width: 150px' },
      { key: 'typeOB', label: 'Type OB', tdClass: 'text-center p-0' },
      { key: 'statusPayment', label: 'Status Payment', tdClass: 'text-center p-0', thStyle: 'width: 250px' },
      { key: 'actualDistance', label: 'Actual Distance', tdClass: 'text-center p-0' },
      { key: 'volumeOb', label: 'Volume OB', tdClass: 'text-center p-0' },
      { key: 'unitPrice', label: 'Unit Price (IDR/BCM)', tdClass: 'text-center p-0' },
      { key: 'totalPrice', label: 'Total Price (IDR)', tdClass: 'text-center p-0' }
    ],
    item: {
      status: 'draft'
    },
    attachment: [],
    options: {
      company: [],
      contractor: []
    },
    attachmentType: ['xlsx', 'xls', 'doc', 'docx', 'pdf'],
    cc: [],
    isEdit: false,
    text: ''
  }),
  async created() {
    this.isEdit = this.$route.meta.isEdit
    this.cc = await api.backupPayment.cc()
    this.fetchDetailOverburden()
    this.fetchCompany()
    this.fetchContractor()
    this.fetchAttachment()
  },
  computed: {
    gridStyle() {
      return {
        gridTemplateColumns: `repeat(${this.numberOfColumns}, minmax(25%, 1fr))`
      }
    }
  },
  methods: {
    async fetchDetailOverburden() {
      const data = await api.overburden.get(this.$route.params.id)
      this.item = data
      this.convertBudgetNumbers()
    },
    async fetchAttachment() {
      const data = await api.overburden.getAttachment(this.$route.params.id)
      this.attachment = data
    },
    onClickBack() {
      localStorage.removeItem('isEdit')
      this.$router.push({ path: '/bup-overburden' })
    },
    onClickEdit() {
      localStorage.setItem('isEdit', true)
      this.isEdit = true
      this.$router.push({ path: `/bup-overburden/${this.$route.params.id}/edit` })
    },
    async onClickSubmit() {
      const valid = await this.$refs.editTable.validate()
      if (!valid) {
        return false
      }
      const data = this.generatePayload()
      try {
        await api.overburden.update(this.$route.params.id, data)
        this.text = 'submitted BUP Overburden'
        this.$bvModal.show('modal-successful')
        setTimeout(() => {
          localStorage.removeItem('isEdit')
          this.onClickBack()
        }, 1500)
      } catch ({ response }) {
        this.$nextTick(() => {
          this.$bvToast.toast(`${response.status} - ${response.data.error.message}`, {
            headerClass: 'd-none',
            solid: true,
            variant: 'danger'
          })
        })
      }
    },
    async fetchCompany() {
      const data = await api.company.list()
      this.options.company = data
    },
    async fetchContractor() {
      try {
        const data = await api.contractor.list()
        this.options.contractor = data

        const idContractors = []
        this.options.contractor.map(v => {
          idContractors.push(v.id)
        })
      } catch (error) {}
    },
    async convertBudgetNumbers() {
      this.item.volume_current_month.map(v => {
        v.volume_item.map(async i => {
          if (i.code) {
            const budgetNumberArray = i.code.split('-')
            i.budget_number_cc = budgetNumberArray[0]
            i.budget_number_plan = budgetNumberArray[1]
            i.budget_number_ac = budgetNumberArray[2]
            i.budget_number_sub_ac = budgetNumberArray[3]
            i.budget_number_pa = budgetNumberArray[4]
            i.budget_number_cc_list = this.cc
            i.budget_number_plan_list = await api.backupPayment.plan({ cc: budgetNumberArray[0] })
            i.budget_number_ac_list = await api.backupPayment.ac({ cc: budgetNumberArray[0], plan: budgetNumberArray[1] })
            i.budget_number_sub_ac_list = await api.backupPayment.subAC({ cc: budgetNumberArray[0], plan: budgetNumberArray[1], ac: budgetNumberArray[2] })
            i.budget_number_pa_list = await api.backupPayment.plan({ cc: budgetNumberArray[0], plan: budgetNumberArray[1], ac: budgetNumberArray[2], sub_ac: budgetNumberArray[3] })
          } else {
            i.budget_number_cc = null
            i.budget_number_plan = null
            i.budget_number_ac = null
            i.budget_number_sub_ac = null
            i.budget_number_pa = null
            i.budget_number_cc_list = this.cc
            i.budget_number_plan_list = []
            i.budget_number_ac_list = []
            i.budget_number_sub_ac_list = []
            i.budget_number_pa_list = []
          }
        })
      })

      this.item.volume_previous_month.map(async i => {
        if (i.code) {
          const budgetNumberArray = i.code.split('-')
          i.budget_number_cc = budgetNumberArray[0]
          i.budget_number_plan = budgetNumberArray[1]
          i.budget_number_ac = budgetNumberArray[2]
          i.budget_number_sub_ac = budgetNumberArray[3]
          i.budget_number_pa = budgetNumberArray[4]
          i.budget_number_cc_list = this.cc
          i.budget_number_plan_list = await api.backupPayment.plan({ cc: budgetNumberArray[0] })
          i.budget_number_ac_list = await api.backupPayment.ac({ cc: budgetNumberArray[0], plan: budgetNumberArray[1] })
          i.budget_number_sub_ac_list = await api.backupPayment.subAC({ cc: budgetNumberArray[0], plan: budgetNumberArray[1], ac: budgetNumberArray[2] })
          i.budget_number_pa_list = await api.backupPayment.plan({ cc: budgetNumberArray[0], plan: budgetNumberArray[1], ac: budgetNumberArray[2], sub_ac: budgetNumberArray[3] })
        } else {
          i.budget_number_cc = null
          i.budget_number_plan = null
          i.budget_number_ac = null
          i.budget_number_sub_ac = null
          i.budget_number_pa = null
          i.budget_number_cc_list = this.cc
          i.budget_number_plan_list = []
          i.budget_number_ac_list = []
          i.budget_number_sub_ac_list = []
          i.budget_number_pa_list = []
        }
      })
    },
    generatePayload() {
      const current = []
      this.item.volume_current_month.map(v => {
        v.volume_item.map(i => {
          let code = ''
          if (i.budget_number_cc) {
            code = `${i.budget_number_cc}-${i.budget_number_plan}-${i.budget_number_ac}-${i.budget_number_sub_ac}-${i.budget_number_pa}`
          } else {
            code = null
          }
          current.push({
            datasurvey_item_id: i.datasurvey_item_id,
            payment_status: i.status_payment.key,
            id: i.id,
            code: code,
            unit_price: i.unit_price,
            total_price: i.total_price
          })
        })
      })
      const previous = []
      this.item.volume_previous_month.map(i => {
        let code = ''
        if (i.budget_number_cc) {
          code = `${i.budget_number_cc}-${i.budget_number_plan}-${i.budget_number_ac}-${i.budget_number_sub_ac}-${i.budget_number_pa}`
        } else {
          code = null
        }
        previous.push({
          datasurvey_item_id: i.datasurvey_item_id,
          payment_status: i.status_payment.key,
          id: i.id,
          code: code,
          unit_price: i.unit_price,
          total_price: i.total_price
        })
      })
      return { current, previous }
    }
  }
}
</script>
